/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface JWTResponse
 */
export interface JWTResponse {
    /**
     * 
     * @type {string}
     * @memberof JWTResponse
     */
    access: string;
    /**
     * 
     * @type {string}
     * @memberof JWTResponse
     */
    refresh: string;
    /**
     * 
     * @type {User}
     * @memberof JWTResponse
     */
    user: User;
}

/**
 * Check if a given object implements the JWTResponse interface.
 */
export function instanceOfJWTResponse(value: object): value is JWTResponse {
    if (!('access' in value) || value['access'] === undefined) return false;
    if (!('refresh' in value) || value['refresh'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function JWTResponseFromJSON(json: any): JWTResponse {
    return JWTResponseFromJSONTyped(json, false);
}

export function JWTResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JWTResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'access': json['access'],
        'refresh': json['refresh'],
        'user': UserFromJSON(json['user']),
    };
}

  export function JWTResponseToJSON(json: any): JWTResponse {
      return JWTResponseToJSONTyped(json, false);
  }

  export function JWTResponseToJSONTyped(value?: JWTResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'access': value['access'],
        'refresh': value['refresh'],
        'user': UserToJSON(value['user']),
    };
}

